import { useEffect } from 'react';
import Cookies from 'js-cookie';

const jwtCookieName = 'edx-jwt-cookie-header-payload';

function useCheckLoggedInCookies() {
  // using effect so hook will not run on every re-render
  useEffect(() => {
    // avoid running in server
    if (typeof window !== 'undefined') {
      // removing cookie set outside of root domain to avoid having duplicate cookie
      Cookies.remove('edxloggedin', { domain: 'www.edx.org' });
      // check if the logged in cookie is set (at root domain .edx.org)
      const hasEdxLoggedInCookie = Cookies.get('edxloggedin') === 'true';
      // if not, check if JWT cookie is present and set edxloggedin to true if it's found
      if (!hasEdxLoggedInCookie) {
        let hasJWTCookie = '';
        if (process.env.GATSBY_COOKIE_ENV === 'stage') {
          hasJWTCookie = Cookies.get(`stage-${jwtCookieName}`); // staging cookies for testing
        } else {
          hasJWTCookie = Cookies.get(jwtCookieName);
        }
        if (hasJWTCookie) {
          if (process.env.GATSBY_COOKIE_ENV === 'stage') {
            Cookies.set('edxloggedin', 'true', { domain: '.stage.edx.org' });
          } else {
            Cookies.set('edxloggedin', 'true', { domain: '.edx.org' });
          }
          // this is to avoid infinite loops in localhost since it has no access to edx.org domain cookies
          if (process.env.GATSBY_ENVIRONMENT === 'development') {
            Cookies.set('edxloggedin', 'true');
          }
          window.location.reload();
        }
      }
    }
  }, []);
}

export default useCheckLoggedInCookies;
